export default function reducer(state={
    windowWidth: 0,
    windowHeight: 0,
}, action){

    switch(action.type){
        case 'CHANGE_WINDOW_WIDTH':{
            return{...state, windowWidth: action.payload}
        }
        case 'CHANGE_WINDOW_HEIGHT':{
            return{...state, windowHeight: action.payload}
        }
    }
    return state

}



// WEBPACK FOOTER //
// ./src/redux/ReduxReducers/WindowDimensionsReducer.js